import React from 'react';
import { DeletedResourceWarning } from './DeletedResourceWarning';

export function createDeletedResourceLabel(
	labelText: string,
	isSingleItem: boolean
): React.ReactNode {
	return (
		<DeletedResourceWarning
			strikethrough={isSingleItem}
			aria-label={`${isSingleItem ? 'This resource' : 'Some of these resources'} has been deleted`}
		>
			{labelText}
		</DeletedResourceWarning>
	);
}
